import { render, staticRenderFns } from "./PrivacyVerification.vue?vue&type=template&id=1287046a&"
import script from "./PrivacyVerification.vue?vue&type=script&lang=js&"
export * from "./PrivacyVerification.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyVerification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports